<template>
  <v-timeline-item left fill-dot icon="call_split">
    <span slot="opposite">{{data.decision}}</span>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'Decision',
  props: {
    data: Object
  }
}
</script>

<style scoped>

</style>
